import Loadable from '@loadable/component';

const GuardList = Loadable(async () => import('./components/guard-list/index.js'));

const guardrailRoutes = {
  '/guardrails': {
    components: { main: GuardList },
    '/:guardId': {
      components: { main: GuardList }
    }
  }
};

export default guardrailRoutes;
